<template>
  <div class="blankBox poolofmoney poolofmoney-tian">
    <div class="poolofmoney-Box">
      <!-- 资金池管理系统的5个tabs栏 -->
      <div class="tabsBox">
        <p
          v-if="tab1"
          :class="baseInfo === 1 ? 'active' : ''"
          style="margin-left:10px;"
          @click="switchBaseInfo(1)"
        >
          {{ $t("poolOfMoney_page.tab1") }}
        </p>
        <p
          v-if="tab2"
          :class="baseInfo === 2 ? 'active' : ''"
          style="margin-left: 15px;"
          @click="switchBaseInfo(2)"
        >
          {{ $t("poolOfMoney_page.tab2") }}
        </p>
        <p
          v-if="tab3"
          :class="baseInfo === 3 ? 'active' : ''"
          style="margin-left: 15px;"
          @click="switchBaseInfo(3)"
        >
          {{ $t("poolOfMoney_page.tab3") }}
        </p>
        <p
          v-if="tab4"
          :class="baseInfo === 4 ? 'active' : ''"
          style="margin-left: 15px;"
          @click="switchBaseInfo(4)"
        >
          {{ $t("poolOfMoney_page.tab4") }}
        </p>
        <p
          v-if="tab5"
          :class="baseInfo === 5 ? 'active' : ''"
          style="margin-left: 15px;"
          @click="switchBaseInfo(5)"
        >
          {{ $t("poolOfMoney_page.tab5") }}
        </p>

      </div>
      <!-- 资金池Tab -->
      <div v-if="baseInfo === 1" class="baseInfoBox">
        <div class="poolofmoney-infoBox">
          <div class="poolofmoney-moneyInfo">
            <p style="color: #828BAF;">{{ $t("poolofmoney.topName1") }}</p>
            <p style="margin-top:15px;">
              {{ data.totalAmount | formatNum }}
            </p>
          </div>
          <div class="poolofmoney-moneyInfo">
            <p style="color: #828BAF;">{{ $t("poolofmoney.topName2") }}</p>
            <p style="margin-top:15px;">
              {{ data.lockAmount | formatNum }}
            </p>
          </div>
          <div class="poolofmoney-moneyInfo">
            <p style="color: #828BAF;">{{ $t("poolofmoney.topName3") }}</p>
            <p style="margin-top:15px;">
              {{ data.useAmount | formatNum }}
            </p>
          </div>
          <div class="poolofmoney-moneyInfo">
            <p style="color: #828BAF;">{{ $t("poolofmoney.topName4") }}</p>
            <p style="margin-top:15px;">
              {{ data.availableBalance | formatNum }}
            </p>
          </div>
        </div>
        <div ref="moneyCharts" style="height:370px;padding-bottom:80px;"/>
      </div>
      <!-- 资金池管理Tab -->
      <div v-if="baseInfo === 2" class="baseInfoBox">
        <fundPoolManagement
          :add-btn="addBtn"
          :reduce-btn="reduceBtn"
        />
      </div>
      <!-- 资金方账号管理Tab -->
      <div v-if="baseInfo === 3" class="baseInfoBox">
        <accountManagement/>
      </div>
      <!-- 邮件管理Tab -->
      <div v-if="baseInfo === 4" class="baseInfoBox">
        <email-management/>
      </div>
      <!--       资金表详情Tab -->
      <div v-if="baseInfo === 5" class="baseInfoBox">
        <fund-statement-detail/>
      </div>
    </div>
  </div>
</template>

<script>
const echarts = require('echarts/lib/echarts')
// 引入柱状图
require('echarts/lib/chart/pie')
// // 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
import Tbutton from '../../components/Tbutton'
import fundPoolManagement from '../../components/fundPoolManagement'
import accountManagement from '../../components/accountManagement'
import emailManagement from '../../components/emailManagement'
import fundStatementDetail from '../../components/fundStatementDetail'
export default {
  name: 'PoolOfmoney',
  components: {
    Tbutton,
    fundPoolManagement,
    accountManagement,
    emailManagement,
    fundStatementDetail
  },
  // provide(){
  //   return{
  //     reload:this.reload
  //   }
  // },
  data() {
    return {
      data: {},
      fundPoolManagementVO: {},
      accountManagementVO: {},
      emailManagementVO: {},
      fundStatementVO: {},
      baseInfo: '',
      //  资金池tab是否展示
      tab1: false,
      tab2: false,
      tab3: false,
      tab4: false,
      tab5: false,
      // 正在点击的tab
      tab: 1,
      // 追加、减少资金按钮是否展示
      addBtn: false,
      reduceBtn: false,
      ifIsSuper: ''
    }
  },
  created() {
    this.isSuper()
    this.getMenuInfo()
  },

  mounted() {
    document.title = this.$t('head.poolFunds')
    const curTab = window.sessionStorage.getItem('poolOfMoneyTab')

    if (curTab) {
      this.$nextTick(() => {
        this.switchBaseInfo(parseInt(curTab))
      })
    }
  },
  methods: {
    // 5个Tabs栏的切换
    switchBaseInfo(value) {
      window.sessionStorage.setItem('poolOfMoneyTab', value)
      if (value == 1) {
        this.tab = 1
        this.getList()
        this.getTabRight(1)
      } else if (value == 2) {
        this.tab = 2
        this.getTabRight(2)
      } else if (value == 3) {
        this.tab = 3
        this.baseInfo = value
      } else if (value == 4) {
        this.tab = 4
        this.baseInfo = value
      } else if (value == 5) {
        this.tab = 5
        this.baseInfo = value
      }
    },
    getList() {
      this.axios.post('/zma/api/zmaFundingPool/find').then(res => {
        // console.log("资金池详情");
        // console.log(res);
        if (res.status) {
          this.data = res.data
          this.userCharts()
        } else {
          this.$message.error(this.$t(`poolOfMoney_error.${res.errorCode}`))
        }
      })
    },

    // 规范饼状图金额格式
    formatMoney(value) {
      const valueNew = value + ''
      let intPart
      if (Number(valueNew) >= 0) {
        intPart = Math.floor(Number(valueNew)) // 获取整数部分
      } else if (Number(valueNew) < 0) {
        intPart = Math.ceil(Number(valueNew)) // 获取整数部分
      }
      intPart = intPart + ''
      const intPartFormat = intPart.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
      let floatPart = '.00' // 预定义小数部分
      const value2Array = valueNew.split('.')
      // =2表示数据有小数位
      if (parseInt(value2Array[1]) > 0) {
        floatPart = value2Array[1] + '' // 拿到小数部分
        if (floatPart.length == 1) {
          return intPartFormat + '.' + floatPart + '0'
        } else if (floatPart.length > 4) {
          const valueNew2 = value.toFixed(4) + ''
          const value2Array2 = valueNew2.split('.')
          const floatPart2 = value2Array2[1] + ''
          return intPartFormat + '.' + floatPart2
        } else {
          return intPartFormat + '.' + floatPart.slice(0, 4)
        }
      } else {
        return intPartFormat + floatPart
      }
    },
    userCharts() {
      const moneyCharts = echarts.init(this.$refs.moneyCharts)
      const config = {
        color: ['#7996F5', '#F5A72C'],
        textStyle: {
          fontSize: 14
        },
        series: [
          {
            name: '资金池',
            type: 'pie',
            radius: '80%',
            center: ['50%', '50%'],
            labelLine: {
              normal: {
                length: 15,
                length2: 18
              }
            },
            label: {
              normal: {
                formatter: data => {
                  //  百分比必须保留两位小数
                  let percent =
                    Math.round(data.percent * Math.pow(10, 2)) /
                    Math.pow(10, 2) // 四舍五入
                  percent = Number(percent).toFixed(2) // 补足位数
                  return [
                    data.name + '：' + percent + '%',
                    '',
                    this.formatMoney(data.value)
                    // data.value
                  ].join('\n')
                }
              }
            },
            data: [
              {
                value: this.data.availableBalance,
                name: this.$t('poolOfMoney_page.available')
              },
              {
                value: this.data.totalAmount - this.data.availableBalance,
                name: this.$t('poolofmoney.topName5')
              }
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      moneyCharts.setOption(config)
    },
    // 判斷是否管理員
    isSuper() {
      this.ifIsSuper = parseInt(this.$utils.getStorage('userProfile').isSuper)
    },
    getMenuInfo() {
      console.log('getMenuInfo')
      // 如果是管理员不用验证，所有权限都有，不是admin，验证权限，没有权限退出登录
      if (this.ifIsSuper == 1) {
        this.getList()
        this.tab3 = true
        this.tab1 = true
        this.tab2 = true
        this.tab4 = true
        this.tab5 = true
        this.addBtn = true
        this.reduceBtn = true
        this.baseInfo = 1
      } else {
        this.axios
          .post('/api/zma/loanMenu/getMenuInfo', { t_y: 5 })
          .then(res => {
            console.log('用户资金池单个菜单权限')
            console.log(res)
            console.log('optTypeList===========' + res.data.optTypeList)
            if (res.status) {
              if (res.data.optTypeList.indexOf(27) > -1) {
                this.tab1 = true
                this.baseInfo = 1
                this.getList()
                console.log(this.baseInfo)
              } else if (res.data.optTypeList.indexOf(27) == -1) {
                this.baseInfo = 2
              }

              if (res.data.optTypeList.indexOf(28) > -1) {
                this.tab2 = true
              }
              if (res.data.optTypeList.indexOf(29) > -1) {
                this.tab2 = true
                this.addBtn = true
                this.reduceBtn = true
              }
              if (res.data.optTypeList.indexOf(30) > -1) {
                this.tab4 = true
              }
              if (res.data.optTypeList.indexOf(31) > -1) {
                this.tab5 = true
              }

              if (res.data.optTypeList.length == 0) {
                this.$router.push('/')
              }
            } else {
              this.$message.error(
                this.$t(`poolOfMoney_error.${res.errorCode}`)
              )
            }
          })
      }
    },
    getTabRight(a) {
      console.log('getTabRight')
      // 如果是管理员不用验证，所有权限都有，不是admin，验证权限，没有权限退出登录
      if (this.ifIsSuper == 1) {
        this.baseInfo = this.tab
        this.tab3 = true
        this.tab1 = true
        this.tab2 = true
        this.addBtn = true
        this.reduceBtn = true
      } else {
        this.axios
          .post('/api/zma/loanMenu/getMenuInfo', { t_y: 5 })
          .then(res => {
            if (res.status) {
              if (a == 1) {
                if (res.data.optTypeList.indexOf(27) > -1) {
                  this.tab1 = true
                  this.baseInfo = 1
                } else {
                  this.baseInfo = 2
                  this.tab1 = false
                }
              }
              if (a == 2) {
                if (
                  res.data.optTypeList.indexOf(28) > -1 ||
                  res.data.optTypeList.indexOf(29) > -1
                ) {
                  this.tab2 = true
                  this.baseInfo = 2
                  if (res.data.optTypeList.indexOf(29) > -1) {
                    this.addBtn = true
                    this.reduceBtn = true
                  } else {
                    this.addBtn = false
                    this.reduceBtn = false
                  }
                } else {
                  this.tab2 = false
                  this.baseInfo = 1
                }
              }
            } else {
              this.$message.error(
                this.$t(`poolOfMoney_error.${res.errorCode}`)
              )
            }
          })
      }
    }
  }
}
</script>
<style lang="scss">
@import "./poolOfMoneyDialog/elDialogChange.scss";
</style>
<style lang="scss" scoped>
.poolofmoney {
  font-size: 14px;
  // 5个tabs的样式start
  .tabsBox {
    width: 1200px;
    height: 50px;
    line-height: 45px;
    box-sizing: border-box;
    background: #f5f6f8;
    box-shadow: inset 0 -1px 0 0 #eaeaea;
    border-radius: 4px 4px 0 0;
    margin-bottom: 20px;
    p {
      margin-top: 5px;
      width: 200px;
      height: 45px;
      color: #81899e;
      text-align: center;
      box-sizing: border-box;
      background: #f6f6f8;
      border: 1px solid #dddddd;
      border-radius: 4px 4px 0px 0px;
      cursor: pointer;
      display: inline-block;
    }
    p.active {
      color: #7996f5;
      background: #ffffff;
      border-bottom: none;
    }
  }
  // 三个tabs的样式end
  &-title {
    padding-left: 28px;
    height: 50px;
    line-height: 50px;
    box-shadow: inset 0 -1px 0 0 #eaeaea;
  }
  &-infoBox {
    margin: 0 auto 26px;
    width: 900px;
    height: 100px;
    background: #f8fafd;
  }
  &-moneyInfo {
    display: inline-block;
    margin: 20px 0;
    text-align: center;
    width: 225px;
    height: 60px;
    box-shadow: inset -1px 0 0 0 #e9ebf0;
  }
}
</style>
